import { getBenefitIdExclusiveEvents, getBenefitIdFactoryVisit } from '@/utils/envUtils'

export const EVENT_TYPES = {
  EXCLUSIVE_EVENTS: 'EXCLUSIVE_EVENTS',
  FACTORY_VISIT: 'FACTORY_VISIT'
} as const

type EventType = keyof typeof EVENT_TYPES

const getBenefitIds = (): Record<EventType, string> => ({
  EXCLUSIVE_EVENTS: getBenefitIdExclusiveEvents(),
  FACTORY_VISIT: getBenefitIdFactoryVisit()
})

export const getBenefitIdByTag = (tag: EventType): string => {
  const benefitId = getBenefitIds()[tag]

  if (!benefitId) {
    throw new Error(`Tipo de evento inválido: ${tag}. Apenas ${Object.keys(EVENT_TYPES).join(' e ')} são permitidos.`)
  }

  return benefitId
}
